import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Typography
} from '@material-ui/core'
import { stripHtml } from 'src/utils/Html/stripHtml'
import { useStyles } from './HorizontalNewsCardSkeleton.styles'

type HorizontalNewsCardProps = {
  idNews: number
  image: string
  category: string | null
  title: string
  text: string
}

const HorizontalNewsCard = ({
  idNews,
  image,
  category,
  title,
  text
}: HorizontalNewsCardProps) => {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <Card className={classes.card}>
      <CardActionArea
        component={RouterLink}
        to={`/news/${category}/${idNews}`}
        className={classes.cardActionAreaMoreRecent}
      >
        <CardMedia
          image={image}
          title={title}
          className={classes.moreRecentImg}
        />
        <CardContent className={classes.moreRecentInformationContainer}>
          <CardHeader title={title} className={classes.moreRecentTitle} />
          <Typography variant="h6" className={classes.moreRecentText}>
            {stripHtml(text)}
          </Typography>
          <CardActions className={classes.actions}>
            <Button className={classes.actionsButton}>
              <Typography variant="body1">{t('button.read-more')}</Typography>
            </Button>
          </CardActions>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export default HorizontalNewsCard
